var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.cssClass,style:(_vm.style),on:{"click":e => this.$emit('click', e)}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.content)+" "),(_vm.showImage)?_c('img',{attrs:{"src":_vm.image,"alt":_vm.text}}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }